var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLearnBg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 380,
    height: 200,
    viewBox: "0 0 380 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M798 -1H297V500H798V-1Z",
    stroke: "#E5E7EB",
    strokeWidth: 1.14908,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M317.957 -1V500",
    stroke: "#E5E7EB",
    strokeWidth: 1.14908,
    strokeMiterlimit: 16,
    strokeDasharray: "2.3 5.36"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M338.519 -1V500",
    stroke: "#E5E7EB",
    strokeWidth: 1.14908,
    strokeMiterlimit: 16,
    strokeDasharray: "2.3 5.36"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M359.477 -1V500",
    stroke: "#E5E7EB",
    strokeWidth: 1.14908,
    strokeMiterlimit: 16,
    strokeDasharray: "2.3 5.36"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M380.434 -1V500",
    stroke: "#E5E7EB",
    strokeWidth: 1.14908,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M297 186.826H798",
    stroke: "#E5E7EB",
    strokeWidth: 1.14908,
    strokeMiterlimit: 10,
    strokeDasharray: "2.3 5.36"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M297 165.868H798",
    stroke: "#E5E7EB",
    strokeWidth: 1.14908,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M297 144.911H798",
    stroke: "#E5E7EB",
    strokeWidth: 1.14908,
    strokeMiterlimit: 10,
    strokeDasharray: "2.3 5.36"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M297 123.953H798",
    stroke: "#E5E7EB",
    strokeWidth: 1.14908,
    strokeMiterlimit: 10,
    strokeDasharray: "2.3 5.36"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M297 103.391H798",
    stroke: "#E5E7EB",
    strokeWidth: 1.14908,
    strokeMiterlimit: 10,
    strokeDasharray: "2.3 5.36"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M297 82.4343H798",
    stroke: "#E5E7EB",
    strokeWidth: 1.14908,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M297 61.4767H798",
    stroke: "#E5E7EB",
    strokeWidth: 1.14908,
    strokeMiterlimit: 10,
    strokeDasharray: "2.3 5.36"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M297 40.5192H798",
    stroke: "#E5E7EB",
    strokeWidth: 1.14908,
    strokeMiterlimit: 10,
    strokeDasharray: "2.3 5.36"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M297 19.9576H798",
    stroke: "#E5E7EB",
    strokeWidth: 1.14908,
    strokeMiterlimit: 10,
    strokeDasharray: "2.3 5.36"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M0 166H380",
    stroke: "#E5E7EB",
    strokeWidth: 1.14908,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLearnBg1);
export default __webpack_public_path__ + "static/media/learn-bg-1.31cc36bc2b7ba4401a77cc0b35fa4051.svg";
export { ForwardRef as ReactComponent };